import React, { useMemo } from 'react'
import './ServicesHero.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useServicesSection } from '../../../../context/ServicesPageContext'
import { resolveMediaUrl } from '../../../../utils/resolveMediaUrl'

const ServicesHero = () => {
  const { section, loading } = useServicesSection('services-hero')

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url
    return url ? resolveMediaUrl(url) : ''
  }, [section])

  if (loading || !section?.fields) return null

  const fields = section.fields

  return (
    <section className="services-hero">
      <div className="services-hero-bg">
        {bgSrc ? <img src={bgSrc} alt="" /> : null}
        <div className="overlay"></div>
      </div>

      <div className="services-hero-content">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="services-hero-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText
            content={fields.title}
            as="h1"
            className="services-hero-title"
          />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="services-hero-description"
          />
        ) : null}
      </div>
    </section>
  )
}

export default ServicesHero
